module.exports = __webpack_public_path__ + "img/5.41967972.jpg";